import logo from './logo.svg';
import './App.css';
import Home from './components/common/Home';
import Project from './components/common/Project';
import About from './components/common/About';
import Contact from './components/common/Contact';
import Profile from './components/common/Profile';
import Entertainment from './components/common/Entertainment';
import {Routes, Route, useLocation} from 'react-router-dom';
import { useEffect } from 'react';
import Signup from './components/common/Signup';
import Crypto from './components/common/Crypto';
import SalaryDetails from './components/common/SalaryDetails';


function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path = "/" element = {<Home/>}/>
        <Route path = "/project" element = {<Project/>}/>
        <Route path = "/about" element = {<About/>}/>
        <Route path = "/contact" element = {<Contact/>}/>
        <Route path = "/expense-manager" element = {<Profile/>}/>
        <Route path = "/tic-tac-toe" element = {<Entertainment/>}/>
        <Route path = "/login" element = {<Signup/>}/>
        <Route path = "/crypto" element = {<Crypto/>}/>
        <Route path = "/salary-calculator" element = {<SalaryDetails/>}/>
      </Routes>
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      
    </>
  );
}

export default App;
